import React, { PropTypes } from 'react';
import { Field } from 'redux-form';
import SubcategorySelect from 'common/containers/subcategory_select';
import PricingPackages from 'marketing/containers/pricing_packages';
import { Meta } from 'common/components/meta';
import { getCanonicalURL } from 'common/utils';

const PricingCategory = ({
  formName, showDifferentiators, showTestimonial, showReviewsAgg, showCta, preheaderContent,
  discount, postPackagesCta
}) => (
  <form className="pricing">
    <div className="row">
      <div className="columns small-16">
        <h2 className="form-header">Show pricing for:</h2>
      </div>
    </div>
    <div className="row">
      <div className="columns small-16 medium-12 large-8 header-select">
        <Field component={SubcategorySelect} formName={formName} name="category" />
      </div>
    </div>
    <Field
      component={PricingPackages}
      formName={formName}
      preheaderContent={preheaderContent}
      showDifferentiators={showDifferentiators}
      showTestimonial={showTestimonial}
      showReviewsAgg={showReviewsAgg}
      showCta={showCta}
      discount={discount}
      postPackagesCta={postPackagesCta}
      name="package"
    />
  </form>
);

PricingCategory.propTypes = {
  formName: PropTypes.string,
  showDifferentiators: PropTypes.bool,
  showTestimonial: PropTypes.bool,
  showReviewsAgg: PropTypes.bool,
  showCta: PropTypes.bool,
  preheaderContent: PropTypes.string,
  discount: PropTypes.number,
  postPackagesCta: PropTypes.object,
};

export default PricingCategory;
